import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, vModelText as _vModelText } from "vue";
const _hoisted_1 = { class: "heading" };
const _hoisted_2 = {
    key: 0,
    class: "valid-messages"
};
const _hoisted_3 = { class: "error" };
const _hoisted_4 = { class: "form-content" };
const _hoisted_5 = {
    key: 0,
    class: "field"
};
const _hoisted_6 = { class: "is_company_checkbox" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_8 = {
    key: 1,
    class: "b2b_fields"
};
const _hoisted_9 = ["value"];
const _hoisted_10 = ["value"];
const _hoisted_11 = { class: "field" };
const _hoisted_12 = {
    key: 2,
    class: "field"
};
const _hoisted_13 = { class: "field" };
const _hoisted_14 = { class: "field" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("input", {
    type: "hidden",
    name: "register",
    value: "1"
}, null, -1);
import { ref, watch } from "vue";
import { __ } from '../../js/helpers/i18n';
import Regulations from "./Regulations.vue";
import Company from "./Company.vue";
import Input from "../Form/Input.vue";
export default /*#__PURE__*/ _defineComponent({
    props: ['b2benabled', 'csrf', 'old', 'errors', 'regulations', 'countries', 'referral'],
    setup(__props) {
        const props = __props;
        const b2bEnabled = ref(props.b2benabled);
        const old = ref(JSON.parse(props.old));
        const b2bCheck = ref(JSON.parse(props.old).is_company == 'on');
        const errors = ref(JSON.parse(props.errors));
        const countries = ref(JSON.parse(props.countries));
        const registerForm = ref();
        const company = ref();
        const formFields = {};
        const password = ref('');
        const passwordConfirmation = ref('');
        const hasReferral = () => {
            return props.referral !== '';
        };
        const handleSubmit = (e) => {
            e.preventDefault();
            let isValidate = true;
            let isCompanyValidate = true;
            if (b2bCheck.value) {
                const formFields = company.value.formFields;
                for (const input in formFields) {
                    formFields[input].validInput();
                    if (!formFields[input].isValid) {
                        isCompanyValidate = false;
                    }
                }
            }
            for (const input in formFields) {
                formFields[input].validInput();
                if (!formFields[input].isValid) {
                    isValidate = false;
                }
            }
            const isValid = registerForm.value.checkValidity();
            if (!isValid)
                registerForm.value.reportValidity();
            if (!isValidate || !isCompanyValidate || !isValid)
                return;
            registerForm.value.submit();
        };
        const setRef = (e) => {
            if (e)
                formFields[e.name] = e;
        };
        const setPass = (value) => {
            password.value = value;
        };
        const setPassConfirm = (value) => {
            passwordConfirmation.value = value;
        };
        watch(password, () => {
            if (passwordConfirmation.value)
                formFields['password_confirmation'].validInput();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(__)('Rejestracja')), 1),
                _createElementVNode("form", {
                    ref: (_value, _refs) => {
                        _refs['registerForm'] = _value;
                        registerForm.value = _value;
                    },
                    action: "",
                    method: "POST"
                }, [
                    (errors.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("span", null, _toDisplayString(error), 1)
                                ]));
                            }), 256))
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                        (b2bEnabled.value && !hasReferral())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("label", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((b2bCheck).value = $event)),
                                        id: "is_company",
                                        class: "valid form-control",
                                        type: "checkbox",
                                        name: "is_company"
                                    }, null, 512), [
                                        [_vModelCheckbox, b2bCheck.value]
                                    ]),
                                    _hoisted_7,
                                    _createElementVNode("span", null, _toDisplayString(_unref(__)('Konto firmowe')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (b2bCheck.value && b2bEnabled.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(Company, {
                                    ref: (_value, _refs) => {
                                        _refs['company'] = _value;
                                        company.value = _value;
                                    },
                                    old: old.value.company ?? {},
                                    errors: errors.value,
                                    countries: countries.value
                                }, null, 8, ["old", "errors", "countries"])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("input", {
                            type: "hidden",
                            name: "_token",
                            value: props.csrf,
                            autocomplete: "off"
                        }, null, 8, _hoisted_9),
                        _createElementVNode("input", {
                            type: "hidden",
                            name: "referral",
                            value: props.referral,
                            autocomplete: "off"
                        }, null, 8, _hoisted_10),
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(Input, {
                                ref: setRef,
                                value: old.value.username,
                                labelText: _unref(__)('Nazwa użytkownika'),
                                name: "username",
                                min: 3,
                                required: ""
                            }, null, 8, ["value", "labelText"])
                        ]),
                        (!hasReferral() || !b2bEnabled.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(Input, {
                                    ref: setRef,
                                    value: old.value.email,
                                    labelText: _unref(__)('Email'),
                                    name: "email",
                                    validType: "email",
                                    required: ""
                                }, null, 8, ["value", "labelText"])
                            ]))
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 3,
                                type: "hidden",
                                name: "email",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((old.value.referral_email) = $event))
                            }, null, 512)), [
                                [_vModelText, old.value.referral_email]
                            ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(Input, {
                                onOnInput: setPass,
                                ref: setRef,
                                labelText: _unref(__)('Hasło'),
                                name: "password",
                                type: "password",
                                validType: "password",
                                required: ""
                            }, null, 8, ["labelText"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(Input, {
                                onOnInput: setPassConfirm,
                                ref: setRef,
                                labelText: _unref(__)('Powtórz hasło'),
                                name: "password_confirmation",
                                type: "password",
                                required: ""
                            }, null, 8, ["labelText"])
                        ])
                    ]),
                    _createVNode(Regulations, {
                        regulations: __props.regulations,
                        "b2b-check": b2bCheck.value
                    }, null, 8, ["regulations", "b2b-check"]),
                    _hoisted_15
                ], 512),
                _createElementVNode("button", {
                    onClick: handleSubmit,
                    class: "btn-black btn primary"
                }, _toDisplayString(_unref(__)("Zarejestruj")), 1)
            ], 64));
        };
    }
});
